import React, { lazy, Suspense, useEffect, useState } from 'react';

const Navbar = lazy(() => import(/* webpackChunkName: "navbar" */ '../../Navbar'));
const Sidebar = lazy(() => import(/* webpackChunkName: "sidebar" */ '../../Sidebar/Sidebar'));

const NavigationLayout = ({ children }) => {
    const [collapsedDesktop, setCollapsedDesktop] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 768);
            setIsTablet(width >= 768 && width <= 1200);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isMobile || isTablet) setSidebarOpen(false);
    }, [isMobile, isTablet]);

    const isOverlayActive = (isMobile || isTablet) && sidebarOpen;
    const effectiveCollapsed = isMobile ? !sidebarOpen : isTablet ? !sidebarOpen : collapsedDesktop;
    const sidebarVisible = isMobile ? sidebarOpen : true;

    const handleToggle = () => {
        if (isMobile || isTablet) {
            setSidebarOpen((prev) => !prev);
            return;
        }
        setCollapsedDesktop((prev) => !prev);
    };

    const handleOverlayClick = () => setSidebarOpen(false);

    return (
        <>
            <Suspense fallback={null}>
                <Sidebar collapsed={effectiveCollapsed} isVisible={sidebarVisible} />
            </Suspense>

            {isOverlayActive && <div className="sidebar_overlay" onClick={handleOverlayClick} />}

            <div className={`custom_content ${effectiveCollapsed ? 'custom_content_collapse' : ''}`}>
                <Suspense fallback={null}>
                    <Navbar collapsed={effectiveCollapsed} onToggle={handleToggle} isMobile={isMobile} />
                </Suspense>

                {children}
            </div>
        </>
    );
};

export default NavigationLayout;

